export const EVENTS_FILTERS = {
    reducerPrefix: 'EventFilters',
    sections: [
        { name: 'period & people' },
        { name: 'event types' },
        { name: 'details' },
        { name: 'additional info', showCustomFields: true, customFieldsObject: 'Project' },
    ],
    filters: [
        {
            name: 'WorkingOn',
            label: 'Period',
            area: 'period & people',
            defaultval: '{today_today}',
            commontype: 'period',
            type: 'period',
        },
        {
            name: 'Booker',
            label: 'Author',
            area: 'period & people',
            defaultval: '{me}',
            commontype: 'booker',
            type: 'booker-selector',
        },
        {
            name: 'modelID',
            label: 'Model',
            area: 'period & people',
            defaultval: undefined,
            commontype: 'model',
            type: 'model-selector',
        },
        {
            name: 'clientID',
            label: 'Client',
            area: 'period & people',
            defaultval: undefined,
            commontype: 'customer',
            type: 'customer-selector',
        },
        {
            name: 'serviceID',
            label: 'Service',
            area: 'period & people',
            defaultval: undefined,
            commontype: 'customer',
            type: 'service-selector',
        },
        {
            name: 'casting',
            label: 'Castings',
            area: 'event types',
            defaultval: {
                eventSubtypeCode: [],
            },
            commontype: 'included',
            type: 'event-casting-subtype-selector',
        },
        {
            name: 'job',
            label: 'Jobs',
            area: 'event types',
            defaultval: {
                eventSubtypeCode: [],
                optionNumber: null,
            },
            commontype: 'included',
            type: 'event-job-subtype-selector',
        },
        {
            name: 'ext',
            label: 'Ext Jobs',
            area: 'event types',
            defaultval: {
                eventSubtypeCode: [],
                optionNumber: null,
            },
            commontype: 'included',
            type: 'event-ext-subtype-selector',
        },
        {
            name: 'travel',
            label: 'Travels',
            area: 'event types',
            defaultval: {
                travelTypes: [],
            },
            commontype: 'included',
            type: 'event-travel-type-selector',
        },
        {
            name: 'followup',
            label: 'Activities',
            area: 'event types',
            defaultval: {
                labels: [],
            },
            commontype: 'included',
            type: 'event-followup-label-selector',
        },
        {
            name: 'roomLodging',
            label: 'Room Lodgings',
            area: 'event types',
            defaultval: true,
            commontype: 'included',
            type: 'event-nosub',
        },
        {
            name: 'extjob',
            label: 'Moves',
            area: 'event types',
            defaultval: true,
            commontype: 'included',
            type: 'event-nosub',
        },
        {
            name: 'meeting',
            label: 'Meetings',
            area: 'event types',
            defaultval: true,
            commontype: 'included',
            type: 'event-nosub',
        },
        {
            name: 'accommodation',
            label: 'Accommodations',
            area: 'event types',
            defaultval: true,
            commontype: 'included',
            type: 'event-nosub',
        },
        {
            name: 'hasTransactions',
            label: 'Has transactions',
            area: 'details',
            defaultval: true,
            commontype: 'included',
            type: 'filter-yes-no-all',
        },
        {
            name: 'projectCategoryID',
            label: 'Category',
            area: 'details',
            defaultval: 1,
            commontype: 'category',
            type: 'category',
        },
    ],
};
